import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import {
    MdPhoneIphone,
    MdWeb,
    MdAccountBalance,
    MdCloud,
    MdStorage,
    MdDesktopMac
} from 'react-icons/md';

const ServiceModal = ({ show, onHide, service }) => {
    if (!service) return null;

    const getServiceIcon = (title) => {
        const iconMap = {
            "Mobile Development": MdPhoneIphone,
            "Web Development": MdWeb,
            "QuickBooks Support": MdAccountBalance,
            "Infrastructure as a Service (IaaS)": MdCloud,
            "Enterprise Cloud": MdStorage,
            "Desktop Support": MdDesktopMac
        };
        
        const IconComponent = iconMap[title] || MdWeb;
        return <IconComponent size={64} className="text-primary" />;
    };

    const handleGetStarted = () => {
        onHide();
        
        setTimeout(() => {
            const contactForm = document.querySelector('.contact-form') || 
                              document.querySelector('[class*="contact"]') || 
                              document.querySelector('form') ||
                              document.querySelector('#contact');
            
            if (contactForm) {
                contactForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
                
                setTimeout(() => {
                    const firstInput = contactForm.querySelector('input[name="name"]') ||
                                     contactForm.querySelector('input[type="text"]') ||
                                     contactForm.querySelector('input[type="email"]') ||
                                     contactForm.querySelector('input') ||
                                     contactForm.querySelector('textarea');
                    
                    if (firstInput) {
                        firstInput.focus();
                    }
                }, 500);
            }
        }, 300);
    };

    const modalContentStyle = {
        backgroundColor: '#0a0a0a',
        border: 'none',
        borderRadius: '0',
        boxShadow: '0 15px 35px rgba(0, 0, 0, 0.5)'
    };

    const modalHeaderStyle = {
        backgroundColor: '#0a0a0a',
        borderBottom: 'none',
        padding: '1.5rem 3rem 2rem',
        position: 'relative'
    };

    const modalBodyStyle = {
        backgroundColor: '#0a0a0a',
        padding: '0 3rem 2rem',
        color: '#ffffff'
    };

    const modalFooterStyle = {
        backgroundColor: '#0a0a0a',
        borderTop: 'none',
        padding: '2rem 3rem 3rem'
    };

    const closeButtonStyle = {
        position: 'absolute',
        top: '1rem',
        right: '1.5rem',
        background: 'transparent',
        border: 'none',
        color: '#ffffff',
        fontSize: '2.5rem',
        fontWeight: '300',
        lineHeight: '1',
        padding: '0.25rem 0.5rem',
        cursor: 'pointer',
        zIndex: '1060'
    };

    return (
        <Modal 
            show={show} 
            onHide={onHide} 
            size="lg" 
            centered
            className="service-modal"
        >
            <div style={modalContentStyle}>
                <div style={modalHeaderStyle}>
                    <button 
                        type="button" 
                        style={closeButtonStyle}
                        onClick={onHide}
                        onMouseEnter={(e) => {
                            e.target.style.opacity = '0.8';
                            e.target.style.transform = 'scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.opacity = '1';
                            e.target.style.transform = 'scale(1)';
                        }}
                    >
                        ×
                    </button>
                    <div className="d-flex align-items-center">
                        <div className="me-4" style={{ width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {getServiceIcon(service.title)}
                        </div>
                        <h3 style={{ marginBottom: '0', color: '#ffffff', fontWeight: '600', fontSize: '1.75rem' }}>
                            {service.title}
                        </h3>
                    </div>
                </div>
                
                <div style={modalBodyStyle}>
                    <div>
                        <p style={{ fontSize: '1rem', lineHeight: '1.6', marginBottom: '1.5rem', color: '#ffffff' }}>
                            {service.description}
                        </p>
                        
                        <div style={{ marginBottom: '1.5rem' }}>
                            <h5 style={{ marginBottom: '1rem', color: '#ffffff', fontWeight: '600', fontSize: '1.25rem' }}>
                                What We Offer:
                            </h5>
                            <div className="row">
                                {service.features.map((feature, index) => (
                                    <div key={index} className="col-md-6 mb-2">
                                        <div className="d-flex align-items-center" style={{ padding: '0.4rem 0' }}>
                                            <i className="fas fa-check-circle text-primary me-2" style={{ fontSize: '0.9rem' }}></i>
                                            <span style={{ color: '#ffffff', fontSize: '0.95rem' }}>{feature}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        
                        <div>
                            <h5 style={{ marginBottom: '1rem', color: '#ffffff', fontWeight: '600', fontSize: '1.25rem' }}>
                                Key Benefits:
                            </h5>
                            <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
                                {service.benefits.map((benefit, index) => (
                                    <li key={index} style={{ 
                                        padding: '0.4rem 0', 
                                        position: 'relative', 
                                        paddingLeft: '1.2rem', 
                                        fontSize: '0.95rem', 
                                        lineHeight: '1.5', 
                                        color: '#ffffff' 
                                    }}>
                                        <span style={{ 
                                            position: 'absolute', 
                                            left: '0', 
                                            top: '0.4rem', 
                                            color: 'var(--color-primary)', 
                                            fontWeight: 'bold' 
                                        }}>
                                            →
                                        </span>
                                        {benefit}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div style={modalFooterStyle} className="d-flex justify-content-center">
                    <Button 
                        variant="primary" 
                        size="lg" 
                        className="px-4 axil-btn btn-fill-primary"
                        onClick={handleGetStarted}
                        style={{
                            fontWeight: '600',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            padding: '0.875rem 2.5rem',
                            borderRadius: '0'
                        }}
                    >
                        Get Started Today
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ServiceModal;
